module.exports = __webpack_public_path__ + "static/media/Costillasvapor.c3f58f26.jpg";